export enum LoginFailure {
    Connection, 
    Credentials, 
    Unknown,
};